module.exports = function () {
    $('.featured-people__more-cta').click(function (e) {
        e.preventDefault();

        var $module = $(this).parents('.featured-people').first();
        $module.find('.featured-people__more-cta-container').addClass('featured-people__more-cta-container--hidden');

        $module.find('.featured-people__more').addClass('featured-people__more--visible');
        AOS.refresh();
    });
};